export const encodeCellKey = (row, col) => {
  return 'row-'+row+'_col-'+col;
};

export const parseCellKey = (cellKey) => {
  // row-0_col-0 => {row: 2, col: 2}
  const bits = cellKey.split('_');
  const parsed = {
    row: 1*bits[0].split('-')[1],
    col: 1*bits[1].split('-')[1]
  };
  return parsed;
};

export const getDestinationCellKey = (fromCellKey, direction, numRows, numCols) => {
  const parsedKey = parseCellKey(fromCellKey);
  switch (direction) {
    case 'left':
      parsedKey.col -= 1;
      break;
    case 'up':
      parsedKey.row -= 1;
      break;
    case 'right':
      parsedKey.col += 1;
      break;
    case 'down':
      parsedKey.row += 1;
      break;
  };
  if (parsedKey.col < 0 || parsedKey.col >= numCols || parsedKey.row < 0 || parsedKey.row >= numRows) {
    return fromCellKey;
  } else {
    return encodeCellKey(parsedKey.row, parsedKey.col);
  }
};

export const isFilledCharacter = (value) => {
  return typeof value !== 'undefined' && value !== '#' && value !== '';
};

export const isStartOfWord = (row, col, solution, direction) => {
  let nextCell;
  let prevCell;
  let isStartOfWord;
  const currentCell = solution[row][col];
  if (!isFilledCharacter(currentCell)) {
    return false;
  }
  if (direction === 'down') {
    if (row > 0) {
      prevCell = solution[row-1][col];
      if (isFilledCharacter(prevCell)) {
        return false;
      }
    }
    if (row+1 === solution.length) {
      return false;
    }
    nextCell = solution[row+1][col];
  } else if (direction === 'across') {
    if (col > 0) {
      prevCell = solution[row][col-1];
      if (isFilledCharacter(prevCell)) {
        return false;
      }
    }
    if (col+1 === solution[row].length) {
      return false;
    }
    nextCell = solution[row][col+1];
  }
  if (nextCell === '#' || nextCell === '') {
    return false;
  }
  return true;
};

export const capitalizeFirstLetter = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

// Can be used to look-up a value in either puzzle or solution, but only
// really practical for clue #s though, since they are unique.
export const getAddressForValue = (value, direction, data) => {
  let address;
  for (let rowIndex=0; rowIndex<data.length; rowIndex++) {
    const rowData = data[rowIndex];
    const colIndex = rowData.indexOf(value);
    if (colIndex > -1) {
      address = {row: rowIndex, col: colIndex};
      break;
    }
  }
  return address;
};

export const getValueAt = (row, col, data) => {
  return data[row][col];
};


export const getAnswerForClue = (num, direction, puzzle, solution) => {
  const address = getAddressForValue(num, direction, puzzle);
  let row = address.row;
  let col = address.col;
  let answer = getValueAt(row, col, solution);
  while (row < solution.length && col < solution[row].length) {
    if (direction === 'Down') {
      row++;
      if (row === solution.length) break;
    } else {
      col++;
      if (col === solution[row].length) break;
    }
    const nextChar = getValueAt(row, col, solution);
    if (isFilledCharacter(nextChar)) {
      answer += nextChar;
    } else {
      break;
    }
  }
  return answer;
};

export const gatherAnswers = (clues, puzzle, solution) => {
  const answers = { Across: [], Down: [] };
  ['Across', 'Down'].map(dir => {
    clues[dir].map(clue => {
      const num = clue[0];
      const answer = getAnswerForClue(num, dir, puzzle, solution);
      answers[dir].push([num, answer]);
    });
  });
  return answers;
};

export const cluesComplete = clues => {
  let cluesComplete = true;
  clues.Across.map(clue => {
    if (clue[1] === '') {
      cluesComplete = false;
    }
  });
  clues.Down.map(clue => {
    if (clue[1] === '') {
      cluesComplete = false;
    }
  });
  return cluesComplete;
};

// Copy nested arrays - e.g. puzzle, solution
export const cloneArray = (data) => {
  let i, copy;

  if( Array.isArray( data ) ) {
    copy = data.slice( 0 );
    for( i = 0; i < copy.length; i++ ) {
      copy[ i ] = cloneArray( copy[ i ] );
    }
    return copy;
  } else if( typeof data === 'object' && data !== null ) {
    throw 'Cannot clone array containing an object!';
  } else {
    return data;
  }
};

// Operate on all cells via a callback function
export const modifyAll = (data, callback) => {
  for (let rowIndex=0; rowIndex<data.length; rowIndex++) {
    const rowData = data[rowIndex];
    for (let colIndex = 0; colIndex<rowData.length; colIndex++) {
      const cell = rowData[colIndex];
      const newValue = callback(cell, rowIndex, colIndex);
      rowData[colIndex] = newValue;
    }
  }
};

export const makeIPuz = (puzzle, solution, clues) => {
  const obj = {
    version: 'http://ipuz.org/v2',
    kind: [ 'http://ipuz.org/crossword#1' ],
    dimensions: { width: puzzle[0].length, height: puzzle.length },
    puzzle: puzzle,
    solution: solution,
    clues: clues
  };
  return obj;
};


export const compareNestedArrays = (first, second) => {
  const resp = [];
  for (let rowIndex=0; rowIndex<first.length; rowIndex++) {
    const respRow = [];
    for (let colIndex=0; colIndex<first[rowIndex].length; colIndex++) {
      const firstArrayCell = first[rowIndex][colIndex];
      const secondArrayCell = second[rowIndex][colIndex];
      let diff = false;
      if (firstArrayCell === secondArrayCell) {
        diff = true;
      }
      respRow.push(diff);
    }
    resp.push(respRow);
  }
  return resp;
};

// Return all of the clues (or answers) concatenated without any spaces
export const concatCrossword = cluesOrAnswers => {
  let result = '';
  for (let direction in cluesOrAnswers) {
    const items = cluesOrAnswers[direction];
    result += items.map(item => (item[1])).join('');
  }
  return result;
};

export const isChinese = testString => {
  const re = /^[\u4E00-\u9FA5]+$/;
  return re.test(testString);
};

export const parseSize = sizeStr => {
  const sizeParts = sizeStr.split('x');
  return {
    width: 1*sizeParts[0],
    height: 1*sizeParts[1]
  };
};

export const buildNestedArrays = (width, height, fillWith) => {
  const arr = [];
  for (let r=0; r<height; r++) {
    const row = [];
    for (let c=0; c<width; c++) {
      row.push(fillWith);
    }
    arr.push(row);
  }
  return arr;
};

// Reconstruct a solution structure using new answers.
// Used for translations.
export const buildSolutionFromAnswers = (answers, puzzle, sizeStr) => {
  const size = parseSize(sizeStr);
  const solution = buildNestedArrays(size.width, size.height, '');
  for (let i in answers.Across) {
    const answer = answers.Across[i];
    const address = getAddressForValue(answer[0], 'Across', puzzle);
    let j=0;
    while (j<answers.Across[i][1].length) {
      solution[address.row][address.col+j] = answers.Across[i][1][j];
      j++;
    }
  }
  for (let i in answers.Down) {
    const answer = answers.Down[i];
    const address = getAddressForValue(answer[0], 'Down', puzzle);
    let j=0;
    while (j<answers.Down[i][1].length) {
      solution[address.row+j][address.col] = answers.Down[i][1][j];
      j++;
    }
  }
  modifyAll(solution, cell => {
    let newValue = cell;
    if (newValue === '') {
      newValue = '#';
    }
    return newValue;
  });
  return solution;
};

export const sanitizeCells = (cells) => {
  modifyAll(cells, cell => {
    let newValue = cell.substring(0,1);
    if (cell !== '#') {
      if (!isChinese(newValue)) {
        newValue = '';
      }
    }
    return newValue;
  });
  return cells;
};
